// TextApp.js
import React, { useState } from "react";
import socializing from "../assets/socializing.jpg";
import PreRegisterModal from "./PreRegisterModal"; // Import the modal

const TextApp = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <div className="flex flex-col md:flex-row justify-center items-center m-5 md:m-20 w-full space-y-8 md:space-y-0">
      {/* Left Section with Image */}
      <div className="flex w-full md:w-1/2 justify-center items-center">
        <img
          src={socializing}
          alt="Group Adventure"
          className="rounded-xl w-3/4 md:w-full max-w-2xl h-auto object-cover"
        />
      </div>

      {/* Right Section with Text */}
      <div className="flex w-full md:w-1/2 flex-col justify-center items-center space-y-4 text-center md:text-left px-4">
        <h1 className="text-3xl md:text-4xl font-medium text-gray-800">
          This is <span className="text-custom-red font-bold">THE</span> app to...
        </h1>
        <p className="text-4xl md:text-6xl font-bold text-custom-red">
          Meet new people,
        </p>
        <p className="text-2xl md:text-4xl font-bold text-black">
          Explore nearby people
        </p>
        <p className="text-2xl md:text-4xl font-bold text-black">
          Do more, <span className="text-custom-red">together</span>
        </p>
        <button
          onClick={handleOpenModal} // Open modal on button click
          className="py-2 px-6 rounded-full bg-custom-red text-white font-semibold text-lg"
        >
          Pre Register
        </button>
      </div>

      {/* Render the modal conditionally */}
      {isModalOpen && <PreRegisterModal isModalOpen={isModalOpen} onClose={handleCloseModal} />}
    </div>
  );
};

export default TextApp;

